export const phoneNumber = "+56931286076";
export const phoneNumber2 = "tel:+56931286076";
